import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const moaService = {
    getAllMoas, 
    updateMoaStatus,
    getMoa,
    updateMoa,
    createMoa,
  };

const MODULE = {
    Moa: 'rnd-moas',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Moa') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllMoas(filter) {
   
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        name: filter.name,
        is_active: filter.isActive
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
    
    return apiHelper(API_URL).get(`/${MODULE.Moa}`, requestOptions)
}


export function updateMoaStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.Moa}/${data.id}`, requestOptions)
}

export async function getMoa(id) {
  return await apiHelper(API_URL).get(`/${MODULE.Moa}/${id}`)
}

export function updateMoa(data) {
  const requestOptions = {
    name: data.name,
    is_active: data.isActive,
  }

  return apiHelper(API_URL).put(`/${MODULE.Moa}/${data.id}`, requestOptions)
}

export function createMoa(data) {
  const requestOptions = {
    name: data.name,
  }
  return apiHelper(API_URL).post(`/${MODULE.Moa}`, requestOptions)
}